import { Controller } from "@hotwired/stimulus"
import { lockScroll, unlockScroll } from "../lib/scroll_lock"

// Lightbox Controller for Admin Panel Evidence Gallery
// Displays evidence images in fullscreen modal
export default class extends Controller {
  static targets = ["modal", "image"]

  open(event) {
    event.preventDefault()
    const imageUrl = event.currentTarget.dataset.lightboxUrlParam
    this.imageTarget.src = imageUrl
    this.modalTarget.classList.remove("hidden")

    // Prevent body scroll when modal is open
    lockScroll(this)
  }

  close(event) {
    // Only close if clicking background or close button
    if (event.target === event.currentTarget || event.target.tagName === "BUTTON") {
      this.modalTarget.classList.add("hidden")
      unlockScroll(this)
    }
  }

  // Close on ESC key
  connect() {
    this.keyHandler = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.keyHandler)
  }

  disconnect() {
    document.removeEventListener("keydown", this.keyHandler)
    unlockScroll(this)
  }

  handleKeydown(event) {
    if (event.key === "Escape" && !this.modalTarget.classList.contains("hidden")) {
      this.modalTarget.classList.add("hidden")
      unlockScroll(this)
    }
  }
}
